import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgFullPageDialog } from "@intelligems/ig-theme";
import { ProgressBarWidgetDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { GlobalStylesHeader } from "@src/domains/WidgetLibrary/GlobalStylesHeader";
import { ProgressBarPreview } from "@src/domains/WidgetLibrary/ProgressBar/ProgressBarPreview";
import { useWidgetSave } from "@src/domains/WidgetLibrary/useWidgetSave";
import { OfferComponentSettingsPageWrapper } from "@src/features/sharedExperience/components/offers/subpages/OfferComponentSettingsPageWrapper";
import { useViewPage } from "@src/hooks/mixpanel";
import {
  getDialogPropDetails,
  isDialogOpen,
  setDialog,
} from "@src/store/slices/global";
import { selectedWidget } from "@src/store/slices/widgets";

export const OfferProgressBarFullPageDialog = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(isDialogOpen("offerProgressBarFullPageEditor"));
  const dialogProps = useSelector(
    getDialogPropDetails("offerProgressBarFullPageEditor")
  ) as
    | {
        widgetId?: string;
        variationId: string;
        widgetType: "discountProgressBar";
      }
    | undefined;

  const currentWidget = useSelector(selectedWidget) as ProgressBarWidgetDto;
  const { save, isSaving } = useWidgetSave(currentWidget);

  const handleClose = () => {
    dispatch(
      setDialog({ dialog: "offerProgressBarFullPageEditor", open: false })
    );
  };

  const handleSave = () => {
    save();
    handleClose();
  };

  const handleCancel = () => {
    handleClose();
  };
  useViewPage("Global Styles - Offer Progress Bar Full Page Editor");
  const content =
    dialogProps && currentWidget ? (
      <Grid container width={"100%"} justifyContent={"center"}>
        <Grid container direction={"column"} rowSpacing={4} width={"1250px"}>
          <Grid item>
            <GlobalStylesHeader
              variantStyle={
                currentWidget.config.desktop?.variant || "progressBar1"
              }
              widgetType={"discountProgressBar"}
            />
          </Grid>
          <Grid item>
            <OfferComponentSettingsPageWrapper
              variationId={dialogProps.variationId}
              widgetType="discountProgressBar"
              hasQuantityButtons={false}
              hasProgressbar={true}
              hasMessageBox={false}
              offerProducts={[]}
              widgetId={dialogProps.widgetId}
              customPreview={
                <ProgressBarPreview
                  mode={"toggle"}
                  widget={currentWidget}
                  widgetOverride={currentWidget}
                  isEdit={true}
                />
              }
            />
          </Grid>
        </Grid>
      </Grid>
    ) : null;

  return (
    <IgFullPageDialog
      showDialog={isOpen}
      handleClose={handleClose}
      content={content}
      yesButtonText={isSaving ? "Saving..." : "Save Widget"}
      handleYesClick={handleSave}
      noButtonText="Cancel"
      handleNoClick={handleCancel}
      shouldNotClose={true}
      hideActions={false}
    />
  );
};
